import {useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';

import GeneralInfo from 'components/Common/GeneralInfo/GeneralInfo';
import Environments from 'components/Drupal/Environments/Environments';

import styles from './DrupalSite.module.scss';

const DrupalSite = () => {
  let {
    params: {projectName},
  } = useRouteMatch();

  const [drupalSites, setDrupalSites] = useState([]);

  const messageWithEnvs = (
    <>
      You are about to delete the site "<strong>{projectName}</strong>" with all its environments:
      <ul>
        {drupalSites.map(site => (
          <li key={site.siteUrl[0]}>{site.siteUrl[0]}</li>
        ))}
      </ul>
      This operation can not be undone. Are you sure that you want to proceed? Please note that:
      <ul>
        <li>It may take some time for the URL(s) to be available for reuse again.</li>
        <li>
          In case you have registered your site for <strong>Web Analytics</strong> and you don't
          need the analytics data anymore, you can request the deletion of the Matomo registration
          via a{' '}
          <a
            className={styles.Link}
            href="https://cern.service-now.com/service-portal?id=sc_cat_item&name=request&fe=web-infrastructure"
            target="_blank"
            rel="noreferrer"
          >
            SNOW ticket
          </a>
          .
        </li>
      </ul>
    </>
  );

  const messageWithoutEnvs = (
    <>
      You are about to delete the site "<strong>{projectName}</strong>". This operation can not be
      undone. Are you sure that you want to proceed? Please note that it may take some time for the
      URL(s) to be available for reuse again.
    </>
  );

  return (
    <>
      <Grid centered>
        <Grid.Column className={styles.DrupalSite}>
          <GeneralInfo
            projectName={projectName}
            projectType="drupal"
            removeProjectMessage={
              Object.keys(drupalSites).length > 0 ? messageWithEnvs : messageWithoutEnvs
            }
          />
          <Environments
            projectName={projectName}
            onDrupalSites={values => {
              setDrupalSites(Object.values(values));
            }}
          />
        </Grid.Column>
      </Grid>
    </>
  );
};

export default DrupalSite;
